import Plan           from "../../../domain/plan/Plan";
import PlanRepository from "../../../domain/plan/PlanRepository";
import ReservationId  from "../../../domain/reservation/ReservationId";
import PlanDataSource from "../../../infrastructure/datasource/plan/PlanDataSource";

class GetPlanReservationId {
  constructor(
    private readonly planRepository: PlanRepository = new PlanDataSource(),
  ) {
  }

  public async execute(reservationId: ReservationId): Promise<Plan> {
    try {
      return await this.planRepository.findByReservationId(reservationId);
    } catch (e) {
      return new Plan();
    } finally {
    }
  }
}

export default GetPlanReservationId;
